/**
 * Gjestens delinger i organisasjonen headeren navngir (sak 232, T5) — `GET /v1/me/guest-scope`.
 *
 * Under `qk.org(orgId)`: svaret gjelder én organisasjon, og å gå ut av gjestemodus bytter den.
 */
import {
  guestScopeResponseSchema,
  sharedVenueViewSchema,
  type GuestScopeResponse,
  type SharedVenueView,
} from '@tvitvi/shared';
import { queryOptions } from '@tanstack/react-query';

import { CACHE } from '@/api/cache-tiers';
import { apiRequest } from '@/api/client';
import { qk } from '@/api/query-keys';

export function guestScopeQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: qk.guestScope(organizationId),
    queryFn: ({ signal }): Promise<GuestScopeResponse> =>
      apiRequest({ path: '/me/guest-scope', schema: guestScopeResponseSchema, signal }),
    ...CACHE.list,
  });
}

/**
 * F18: salen eller arrangementet slik mottakeren leser det — `GET /v1/me/shares/:grantId/view`.
 * Menneskets, som «delt med meg», og uten organisasjonsheader (ruta er `@OrgScope('none')`).
 */
export function sharedVenueViewQueryOptions(grantId: string) {
  return queryOptions({
    queryKey: qk.mySharedView(grantId),
    queryFn: ({ signal }): Promise<SharedVenueView> =>
      apiRequest({
        path: `/me/shares/${encodeURIComponent(grantId)}/view`,
        schema: sharedVenueViewSchema,
        signal,
        sendOrganizationHeader: false,
      }),
    ...CACHE.detail,
    retry: false,
  });
}
